import React, { useContext, useMemo } from "react";
import { TaggingContext, TaggingProvider } from "../tagging-context-file";
import styles from "@/page-components/taggings/tagging.module.css";
import TaggingHeading from "../components/tagging-heading.part";
import TaggingTableSection from "../components/tagging-table-section.part";
import DeleteConfirmationSection from "@/page-components/taggings/components/delete-confirmation-modal.part";
import { useTagsDelete } from "@/services/taggings/delete-virtual-tag.repo";

const AWSTagging = () => {
  return (
    <TaggingProvider>
      <TaggingPage />
    </TaggingProvider>
  );
};

const TaggingPage = () => {
  const context = useContext(TaggingContext);
  const service = "aws";

  const DeleteQuery = useMemo(
    () => ({
      service: service,
      id: context?.SelectedTagID,
    }),
    [context?.SelectedTagID]
  );

  const {
    data: deleteData,
    isLoading: deleteLoading,
    error: deleteError,
    isSuccess: deleteSuccess,
  } = useTagsDelete(DeleteQuery, [], !!context?.SelectedTagID);
 

  return (
    <>
      <div className={styles.mainPage}>
        <TaggingHeading
          service={service}
          deleteError={deleteError}
          deleteSuccess={deleteSuccess}
          deleteLoading={deleteLoading}
          deleteData={deleteData}
        />
        <div className={styles.headerSection} style={{ height: "100vh" }}>
          <TaggingTableSection
            service={service}
            deleteSuccess={deleteSuccess}
          />
        </div>
        <div className={styles.headerSection}></div>
      </div>

      {context?.confirmationmodal && (
        <div className={styles.customeOverlay}>
          <div className={styles.conformationBox}>
            <DeleteConfirmationSection
              deleteLoading={deleteLoading}
              deleteData={deleteData}
              name="Tag"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AWSTagging;
